<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.search-duotone"></svg-vue>
          <h1 class="content-title">
            {{ $t('Search engine optimization configs') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/settings">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="save">
          <div class="px-4 py-5 bg-white sm:p-6">
            <div class="grid grid-cols-3 gap-6">
              <div class="col-span-3">
                <label class="form-label" for="meta_home_title">{{ $t('Home page title') }}</label>
                <div class="pt-1">
                  <input :placeholder="$t('Home page title')" class="form-input" id="meta_home_title" required v-model="seo.meta_home_title" />
                </div>
                <p class="form-description-text">{{ $t("Define the title of the application' home page to improve SEO positioning") }}.</p>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="meta_keywords">{{ $t('Meta keywords') }}</label>
                <div class="pt-1">
                  <input :placeholder="$t('Meta keywords')" class="form-input" id="meta_keywords" required v-model="seo.meta_keywords" />
                </div>
                <p class="form-description-text">{{ $t('Define the keywords of the application to improve SEO positioning') }}.</p>
              </div>
              <div class="col-span-3">
                <label class="form-label" for="meta_description">{{ $t('Meta description') }}</label>
                <div class="pt-1">
                  <textarea
                    :placeholder="$t('Meta description')"
                    class="form-input"
                    id="meta_description"
                    required
                    v-model="seo.meta_description"
                  ></textarea>
                </div>
                <p class="form-description-text">{{ $t('Define the description of the application to improve SEO positioning') }}.</p>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <button class="btn btn-app rounded-md shadow-sm" type="submit">
                {{ $t('Save') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  name: 'seo',
  data() {
    return {
      loading: true,
      seo: {
        meta_home_title: null,
        meta_keywords: null,
        meta_description: null,
      },
    };
  },
  mounted() {
    this.get();
  },
  methods: {
    get() {
      axios
        .get(route('settings.get.seo'))
        .then((response) => {
          this.seo = response.data;
          this.loading = false;
        })
        .catch(function() {
          this.$router.push('/admin/settings');
        });
    },
    save() {
      this.loading = true;
      axios
        .post(route('settings.set.seo'), this.seo)
        .then((response) => {
          window.app.meta_home_title = this.meta_home_title;
          this.$store.commit('setSettings', window.app);
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
